import React from 'react';
import { Lock } from 'lucide-react';

/**
 * Component that shows content with blur effect for restricted data
 * Used to protect sensitive historical data from cashiers
 */
const PrivacyBlur = ({ children, isBlurred, showLockIcon = false, className = '' }) => {
  if (!isBlurred) {
    return <>{children}</>;
  }

  return (
    <div className={`relative inline-flex items-center ${className}`}>
      <span 
        className="blur-[5px] select-none pointer-events-none"
        style={{ 
          WebkitUserSelect: 'none',
          MozUserSelect: 'none',
          msUserSelect: 'none',
          userSelect: 'none'
        }}
      >
        {children}
      </span>
      {showLockIcon && (
        <Lock 
          size={12} 
          className="absolute right-0 top-1/2 -translate-y-1/2 text-gray-400 ml-1" 
        />
      )}
    </div>
  );
};

/**
 * Component for blurred table rows
 * Shows entire row with blur effect
 */
export const PrivacyBlurRow = ({ children, isBlurred, className = '' }) => {
  if (!isBlurred) {
    return <tr className={className}>{children}</tr>;
  }

  return (
    <tr 
      className={`${className} relative`}
      style={{
        position: 'relative'
      }}
    >
      {React.Children.map(children, (child) => {
        if (!React.isValidElement(child)) return child;
        
        return React.cloneElement(child, {
          ...child.props,
          children: (
            <span 
              className="blur-[5px] select-none pointer-events-none inline-block"
              style={{ 
                WebkitUserSelect: 'none',
                MozUserSelect: 'none',
                msUserSelect: 'none',
                userSelect: 'none'
              }}
            >
              {child.props.children}
            </span>
          )
        });
      })}
    </tr>
  );
};

/**
 * Privacy notice banner for cashiers
 */
export const PrivacyNoticeBanner = ({ show }) => {
  if (!show) return null;

  return (
    <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 mb-6 flex items-center space-x-3">
      <div className="bg-amber-100 rounded-full p-2">
        <Lock className="text-amber-600" size={20} />
      </div>
      <div>
        <p className="text-amber-800 font-medium">Modo de Privacidad Activo</p>
        <p className="text-amber-600 text-sm">
          Solo puedes ver los datos de hoy. Los datos históricos están protegidos.
        </p>
      </div>
    </div>
  );
};

export default PrivacyBlur;
